import { render, staticRenderFns } from "./UserWalletStatus.vue?vue&type=template&id=41a234b6&scoped=true&"
import script from "./UserWalletStatus.vue?vue&type=script&lang=js&"
export * from "./UserWalletStatus.vue?vue&type=script&lang=js&"
import style0 from "./UserWalletStatus.vue?vue&type=style&index=0&id=41a234b6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41a234b6",
  null
  
)

export default component.exports